export default "__VITE_ASSET__Dwv9YyS3__"